import { useOnlineScheduler } from 'app/components/online-scheduler/useOnlineScheduler'
import { OnlineSchedulerShadcnComponent } from 'app/components/online-scheduler/OnlineSchedulerShadcnComponent'

export default function OnlineSchedulerIndex(): React.ReactElement {
  const props = useOnlineScheduler()
  return <OnlineSchedulerShadcnComponent {...props} />
}
